import { memo } from 'react';

import type { ICellRendererParams } from 'ag-grid-community';

import { useTooltip, Tooltip } from '../../../../modules/EntitiesGrid';
import { ClampedTypography } from '../../../base';

const UserFunctionRenderer = (props: ICellRendererParams) => {
  const { value } = props;
  const showedValue = value;
  const { ref, tooltipProps } = useTooltip();

  return (
    <Tooltip title={showedValue} {...tooltipProps}>
      <ClampedTypography ref={ref} variant='body2' lineclamp={5}>
        {showedValue}
      </ClampedTypography>
    </Tooltip>
  );
};

export default memo(UserFunctionRenderer);
